import { ReactElement } from 'react';

import { TableCell, TableHead, TableRow } from '@mui/material';

export const TransactionsTableHead = (): ReactElement => {
  return (
    <TableHead>
      <TableRow>
        <TableCell>ID</TableCell>
        <TableCell>DATE AND TIME</TableCell>
        <TableCell>REFERENCE NUMBER</TableCell>
        <TableCell>TICKET</TableCell>
        <TableCell>EMAIL</TableCell>
        <TableCell>STATUS</TableCell>
        <TableCell>ACTIONS</TableCell>
      </TableRow>
    </TableHead>
  );
};
